import { Icon, IconButton, IconButtonProps } from '@chakra-ui/react'
import React from 'react'
import IconPhoneDelete from '~/assets/svgs/icon-phone-delete.svg?react'

import { useDeleteButtonStyle } from './componentStyles/DeleteButton.style'

type DeleteButtonProps = {
  handleHoldDelete: () => void
  handleDelete: () => void
} & Omit<IconButtonProps, 'aria-label'>
export const DeleteButton = ({
  handleDelete,
  handleHoldDelete,
  ...rest
}: DeleteButtonProps) => {
  const styles = useDeleteButtonStyle()
  return (
    <IconButton
      sx={styles.iconButton}
      aria-label="Backspace"
      onMouseDown={handleHoldDelete}
      onMouseUp={handleDelete}
      {...rest}
    >
      <Icon sx={styles.icon} as={IconPhoneDelete} />
    </IconButton>
  )
}
